export default __webpack_public_path__ + "static/platinum-ea6866b6b87010d982c6d97548ad24b6.png";